import React from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import FooterBlack from "components/Footers/FooterBlack.js";
import ProductCard from "views/edge-pages/ProductCard.js";
import { APPS } from "data/apps.js";

function ProductsHub() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="edge-page">
      <div className="edge-page-brand-nav">
        <Container>
          <Link to="/presentation">Edge<span>Ventures</span></Link>
        </Container>
      </div>
      <section className="edge-page-hero edge-products-hero">
        <Container>
          <span className="edge-page-eyebrow">{"// our apps"}</span>
          <h1 className="edge-page-title">
            Our <span>Products</span>
          </h1>
          <p className="edge-page-subtitle">
            Apps and tools built by Edge Ventures. Real products — from AI-powered
            mobile apps to developer utilities. Select a product to find support,
            privacy policy, and terms of service.
          </p>

          <div className="products-hub-grid">
            {APPS.map((app) => (
              <ProductCard key={app.slug} app={app} />
            ))}
          </div>
        </Container>
      </section>

      <FooterBlack />
    </div>
  );
}

export default ProductsHub;
